import { useContext, useState } from 'react';
import './updatePassword.scss';
import { useParams, useNavigate } from 'react-router-dom';
import apiRequest from '../../lib/apiRequest';
import { AuthContext } from '../../context/AuthContext';

function UpdatePassword() {
  const { currentUser, updateUser } = useContext(AuthContext);
  const [error, setError] = useState('');
  const [isLoading, setIsLoading] = useState(false);
  const { id, token } = useParams();

  const navigate = useNavigate();

  const handleSubmit = async (e) => {
    e.preventDefault();
    setIsLoading(true);
    setError('');
    const formData = new FormData(e.target);

    const { password, confirmPassword } = Object.fromEntries(formData);

    try {
      const res = await apiRequest.put(`/users/reset/${id}/${token}`, {
        password,
        confirmPassword,
      });
      if (res) {
        setError('Password updated! Now please Log in!');
      }
    } catch (err) {
      setError(err.response.data.message);
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <div className="login">
      <div className="formContainer">
        <form onSubmit={handleSubmit}>
          <h1>Update Password</h1>
          <p>
            To restore an access to your account,<br></br> please create a new
            password:
          </p>

          <input
            id="password"
            required
            name="password"
            type="password"
            placeholder="Enter your new password"
          />

          <input
            id="confirmPassword"
            required
            name="confirmPassword"
            type="password"
            placeholder="Confirm new password"
          />

          <button disabled={isLoading}>Update</button>
          {error && <span>{error}</span>}
        </form>
      </div>
    </div>
  );
}

export default UpdatePassword;
